import { HttpClient } from '@angular/common/http';
import { APPLICATION_ROUTES, PUBLIC_ROUTES } from './constants/application-routes';
import { CORRELATION_ID_COOKIE_NAME, ZCI_CORRELATION_ID_NAMESPACE } from '../common/constants/util';
import * as uuid from 'uuid';
import { LoggerService } from './services/logger/logger.service';

const publicPages: Array<string> = Object.values(PUBLIC_ROUTES);

export function initializeApp(http: HttpClient, window: Window, logger: LoggerService) {
    setCorrelationCookie(window, logger);

    if (window.location.pathname.includes(APPLICATION_ROUTES.GENERIC_ERROR)) {
        window.location.pathname = APPLICATION_ROUTES.OWN_ACCOUNTS;
        return () => Promise.resolve();
    }

    for (const key of publicPages) {
        let match = false;
        if (
            key === PUBLIC_ROUTES.LITE_REGISTRATION_GRANTEE_WELCOME ||
            key === PUBLIC_ROUTES.LITE_REGISTRATION_ALMOST_THERE
        ) {
            match = window.location.pathname.startsWith('/lite-registration');
        } else {
            match = window.location.pathname.includes(key);
        }
        if (match) {
            return () => Promise.resolve();
        }
    }

    // No longer need to check logon here; handled by AuthRedirectInterceptor
    return () => Promise.resolve();
}

function setCorrelationCookie(win: Window, logger: LoggerService) {
    try {
        // Fast regex presence check (start of string or after semicolon + optional space)
        const exists = /(?:^|;\s*)ZCI_CORRELATION_ID=/.test(win.document.cookie || '');
        if (exists) return;

        const sessionId = uuid.v4();
        const correlationId = uuid.v5(sessionId, ZCI_CORRELATION_ID_NAMESPACE);
        win.document.cookie = `${CORRELATION_ID_COOKIE_NAME}=${correlationId}; Path=/; Domain=.vanguard.com; Secure; SameSite=Strict`;
    } catch {
        logger.warn('Failed setting correlation cookie');
    }
}
